import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import MunicipalitySortingTrendWrapper from '@/components/municipality-sorting-trend/wrapper'
import MunicipalitiesPublicLoader from '@/wrappers/municipalities-public-loader'
import { selectedMunicipalityIdAtom } from '@/state'
import MunicipalityLoader from '@/wrappers/municipality-loader'

function MunicipalitySortingTrendView() {

    const title = 'Trend separace v obci'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Typography variant="h2" component="h1" gutterBottom>
                    {title}
                </Typography>
                {municipalityId ?
                    <MunicipalitiesPublicLoader>
                        {municipalities => (
                            <MunicipalityLoader>
                                {municipality => (
                                    <MunicipalitySortingTrendWrapper
                                        publicMunicipalities={municipalities}
                                        municipality={municipality}
                                    />
                                )}
                            </MunicipalityLoader>
                        )}
                    </MunicipalitiesPublicLoader>
                    :
                    <Box>
                        Vyberte prosím konkrétní obec výše.
                    </Box>
                }
                
            </CustomPaper>
        </>
    )
}

export default MunicipalitySortingTrendView
